<div id="spring-break" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
    <div class="spring-break_banner">
        <div class="overlay-layer"></div>
        <!--<app-language></app-language>-->

        <div class="language_container">
            <div *ngIf="(langChosen=='ar')?true:false; else english">
                <button class="language-button" value="en" (click)="languageChange('en')">
                    <p>English</p>
                    <div class="flag en"></div>
                </button>
            </div>
            <ng-template #english>
                <button class="language-button" value="ar" (click)="languageChange('ar')">
                    <p>العربية</p>
                    <div class="flag ar"></div>
                </button>
            </ng-template>
        </div>

        <div class="container" >
            <div class="content">
                <div class="logo">
                    <img src="assets/img/spring-break/spring-logo.png" width="250" alt="">
                </div>
                <div class="text">
                    <h1>#StayHome_PlaySafe</h1>
                    <p>{{language.banner_text}}</p>
                    <div class="supporters">
                        <h2>{{language.supported_by}}</h2>
                        <div class="supporters-logos">
                            <img src="assets/img/spring-break/pubg-logo.png" alt="">
                            <img src="assets/img/spring-break/coco-logo.png" alt="">
                            <img src="assets/img/spring-break/ah-logo.png" alt="">
                            <img src="assets/img/spring-break/smile-logo.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>




    <div class="container">
        <div class="ah-container">
            <div class="col-lg-2 col-md-2 col-xs-12 zero_margin">
                <div class="logo">
                    <img src="assets/img/spring-break/ah-logo-hr.png" alt="">
                </div>
            </div>
            <div class="col-lg-6 col-md-8 col-xs-12 zero_margin">
                <div class="flex_block">
                    <h1>{{language?.ah_title}}</h1>
                    <p>{{language?.ah_text}}
                        <strong style="font-family:'proxima-nova-bold-webfont', 'Frutiger LT Arabic 65 Bold'">{{language?.hashtag}}</strong>
                    </p>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-xs-12 zero_margin" style="text-align: center">
                <div class="go_button sm square" (click)="eventService.shareEvent()">
                    <i class="icon-facebook"></i>
                    {{language.share}}
                </div>
            </div>
            <div class="col-lg-2 col-xs-12 zero_margin">
                <div class="counter">
                    <div class="flex_block" style="flex-flow: row">
                     <i class="icon-users" style="font-size: 20px;"></i>  {{eventService.Event.value.participants_count}}
                    </div>
                    <div style="border-radius:180px; width:30px; height:30px; padding:10px; background: #9d4a4f; font-size: 20px;
display: flex; justify-content: center; align-items: center;">
                        =
                    </div>
                    <div class="flex_block"  style="flex-flow: row">
                        <i class="icon-money" style="font-size: 20px;"></i> {{eventService.Event.value.participants_count}}
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="title">
        <h1>{{language.select_game}}</h1>
    </div>


    <div class="container">

        <div class="games-container">
            <div class="game-block" routerLink="../{{game}}" routerLinkActive="active" *ngFor="let game of games"
                 [ngStyle]="{'background-image': 'url(assets/img/games/'+game+'/block.jpg)'}">
                <div class="cover {{game}}"></div>
                <img src="assets/img/games/{{game}}/logo.png" alt="">
            </div>

            <div class="splash"></div>

        </div>
    </div>

    <div class="title">
        <h1>{{language.covid_title}}</h1>
        <p>{{language.covid_text}}</p>
    </div>
    <app-covid19-advice></app-covid19-advice>


    <app-footer></app-footer>
</div>

